module.exports = __webpack_public_path__ + "static/media/webpack.2acc9669.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/webpack.png
// module id = 42
// module chunks = 0